export default function heatInputValue(voltage, current, travel_speed, welding_process) {
  let voltage_arr = voltage || [0, 0]
  let current_arr = current || [0, 0]
  let travel_speed_arr = travel_speed || [0, 0]
  let minHeatInput = +calculateHeatInput(voltage_arr[0], current_arr[0], travel_speed_arr[1], welding_process).toFixed(2)
  let maxHeatInput = +calculateHeatInput(voltage_arr[1], current_arr[1], travel_speed_arr[0], welding_process).toFixed(2)
  return [minHeatInput, maxHeatInput]
}

function calculateHeatInput(voltage, current, travel_speed, welding_process) {
  let k;
  const processName = welding_process && welding_process.name;
  
  switch (processName) {
    case '121':
      k = 1.0;
      break;
    case '111':
    case '131':
    case '135':
    case '114':
    case '136':
    case '137':
    case '138':
    case '139':
      k = 0.8;
      break;
    case '141':
    case '15':
      k = 0.6;
      break;
    default:
      k = 1.0;
  }
  
  if (travel_speed > 0.0) {
    return (voltage * current * 60.0) / (travel_speed * 1000.0) * k;
  } else {
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/components/Wps/helpers/heatInputValue.js